//https://stackoverflow.com/questions/54892403/usereducer-action-dispatched-twice
import React, { createContext, useReducer } from 'react';
import { storageSupported } from './Dashboard/helpers/validateLocalStorage';
import { createAnalyticsState } from './Dashboard/Analytics/createAnalyticsState';
import LocalStorage from 'utils/LocalStorage';
import createSectionViewStoreProperty from 'components/Dashboard/ParliamentLive/createSectionViewStoreProperty';
import dynamicTextImage from 'components/Dashboard/Influence/CrmEmails/TinyEditor/dynamicTextImage';

const gimmicks = ['test', 'hi', 'hello', 'hola'];
const net_api_url = `${import.meta.env.VITE_APP_DOTNETAPIURL}`;
const app_url = `${import.meta.env.VITE_APP_APPURL}`;
export const initialCrmEmailState = () => ({
  crmEmailId: null,
  from: '',
  sendRecords: [],
  emailDomainId: null,
  subject: '',
  body: `<p style="font-family: Arial, Helvetica, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; font-size: 15px; margin: 0; color: #00122b;">Dear&nbsp;${dynamicTextImage(
    'salutation'
  )},&nbsp;</p>\n<p style="font-family: Arial, Helvetica, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'; font-size: 15px; margin: 0; color: #00122b;">&nbsp;</p>`,
  toList: [],
});

const initialState = {
  net_api_url: `${import.meta.env.VITE_APP_DOTNETAPIURL}`,
  app_url: `${import.meta.env.VITE_APP_APPURL}`,
  isHiddenMenu: true,
  consultations: {},
  upComingEvents: {},
  gimmickWord: '',
  search: {
    searchState: false,
    activeSearch: false,
    gimmicks: gimmicks,
    query: '',
    list: null,
  },
  sectionsView: createSectionViewStoreProperty(),
  locationToStorage: '',
  hash: {},
  settings: {
    createKeywordFromAlert: '',
    keywordId: '',
    listToEdit: '',
  },
  keywordsLists: [],
  InitialKeywordsState: {},
  IsSavingKeywordList: false,
  remainingKeywords: 0,
  activePlan: {},
  activeSubscriptions: {},
  userProfile: {},
  team: {},
  emailAlerts: [],
  clientsAlerts: [],
  clients: [],
  trialBannerHeight: 0,
  listPosition: null,
  scrollTopicPosition: null,
  loadingNumbers: true,
  additionalFilters: {},
  unseenNumbersCurrentList: {},
  modifiedListId: null,
  readyKeywordLists: false,
  totalNumbers: {},
  referenceState: {
    activeReference: false,
    keywords: [],
    andKeywords: [],
    keywordExclusions: [],
  },
  openResearchPopup: false,
  clickedOnContentUrl: null,
  searchResultsReturnUrl: [],
  clearValueSimpleSearchBar: false,
  processingMarkItemAsRead: false,
  useLocalStorageForReference: false,
  analyticsState: createAnalyticsState(),
  chartState: {},
  memoryMasterTopic: false,
  directLoadSentimentPage: true,
  promptFromWritingAssistant: null,
  topicForReport: null,
  updateToCreateReport: null,
  autofocusCommentary: false,
  temporaryReportState: null,
  updateBeforCreateReportLocation: null,
  clientToSwitchOnReports: null,
  changesOnReports: false,
  reportDefaultsSelected: null,
  changeOfGraphFilters: false,
  analyticsHubSearchQuery: null,
  analyticsRateLimitReached: false,
  targetClient: null,
  readySetCurrentTeam: null,
  dispatchSearchForClients: null,
  changingClientFinished: false,
  realtimeEvents: null,
  selectedUpdates: [],
  selectedUpdatesIds: [],
  temporarySelectedUpdates: null,
  createReportFromUpdatePopup: null,
  updatesToCreateReport: null,
  showUpdateDescriptionModal: false,

  listDomainsVerified: {
    verifiedDomains: [],
    allDomains: [],
    verifiedEmailAddresses: [],
    allEmailAddresses: [],
    domainsProccessing: true,
  },
  allStakeholders: [],
  selectedStakeholders: {
    selectedAll: false,
    selectedAllVisible: [],
    selectedIds: [],
  },
  selectedCrmContacts: {
    selectedAll: false,
    selectedAllVisible: [],
    selectedIds: [],
  },
  selectedGroups: {
    selectedAll: false,
    selectedIds: [],
  },
  previousStoredSelectedCrmContacts: {
    selectedAll: false,
    selectedAllVisible: [],
    selectedIds: [],
  },
  hideInfluenceSidebar: false,
  addedCustomContacts: [],
  crmContactsTableOnSort: { sort: '' },
  crmEmailsTableOnSort: { sort: '' },
  showAddContactModal: false,
  availableStakeholders: null,
  contactIdsCheck: {},
  crmContactsTotalHits: null,
  showAddTagsModalCrmContacts: { show: false, preselectedContact: undefined },
  totalEmailsCount: 0,
  teamContentResultsQntty: 0,
  teamContentFilter: null,
  updateCustomContactTitle: { firstName: '', lastName: '' },
  showRemoveContactsModal: false,
  showRemoveContactTagsModal: false,
  newContactFromSelect: null,
  removedContactsQntty: null,
  searchEmailsString: '',
  deleteStakeholderId: null,
  crmContactsQtty: null,
  showChangeChampionStatusModal: false,
  newlyAddedContacts: [],
  engagementStatisticItem: {},
  engagementStatisticsResult: [],
  contactsTags: [],
  contactOnGroupUpdated: null,
  showTailorSummaryModal: false,
  initialOpenAiSummary: false,
  stakeholderMobileSection: '',
  loadingCreateSummary: false,
  selectedContactTags: [],
  showStakeholderCrmPopup: false,
  showContactsPopup: { show: false },
  customContactInfo: null,
  group: null,
  groupsAlerts: [],
  shareStakeholderPopupProps: {},
  showGimmickPopup: false,
  remainingCredits: null,
  scrollPositionPriorityUpdates: null,
  dasboardPriorityUpdatesFeedback: [],
  discardChangesShown: false,
  customContactsOnSearch: false,
  defaultUrl: storageSupported ? LocalStorage.getItem('defaultUrl') : null,
  markedEverythingAsRead: false,
};
const store = createContext(initialState);
const { Provider } = store;

function reducer(state, action) {
  switch (action.type) {
    case 'MODIFY_SECTION':
      return {
        ...state,
        [action.parameter]: action.value,
      };
    case 'SHOW_HIDE_MENU':
      return { ...state, isHiddenMenu: action.value };
    default:
      throw new Error();
  }
}

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider, net_api_url, app_url };
